import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import PerfectScrollbar from "perfect-scrollbar";
import Dashboard from "components/dashboard/dashboard";
import Jugadores from "components/jugadores/jugadores";
import Equipos from "components/equipos/equipos";
import Sedes from "components/sedes/sedes";
import Usuarios from "components/usuarios/usuarios";
import Torneos from "components/torneos/torneos";
import Resultados from "components/resultados/resultados";
import Noticias from "components/noticias/noticias";
import Sidebar from "components/sidebar/sidebar";
import TorneosForm from "components/torneos/torneosForm";
import SedesForm from "components/sedes/sedesForm";
import UsuariosForm from "components/usuarios/usuariosForm";
import EquiposForm from "components/equipos/equiposForm";
import JugadoresForm from "components/jugadores/jugadoresForm";
import NoticiasForm from "components/noticias/noticiasForm";
import AdminNavbar from "./adminNavbar";
var ps;

const Admin = (props) => {
  const [sidebarMini, setSidebarMini] = React.useState(false);
  const [backgroundColor, setBackgroundColor] = React.useState("pink");
  const [dashboardTitle, setDashboardTitle] = React.useState("");
  const mainPanel = React.useRef();
  const location = useLocation();

  // Cada página administra su propio ciclo de carga; Admin sólo baja las props.
  const loadingProps = { onLoading: props.onLoading, onDoneLoading: props.onDoneLoading };

  let routes = [
    {
      path: "/sedes",
      name: "sedes",
      icon: "fas fa-map-marker-alt",
      component: <Sedes {...loadingProps} />,
      layout: "/admin",
    },
    {
      path: "/equipos",
      name: "equipos",
      icon: "fas fa-tshirt",
      component: <Equipos {...loadingProps} />,
      layout: "/admin",
    },
    {
      path: "/jugadores",
      name: "jugadores",
      icon: "fas fa-running",
      component: <Jugadores {...loadingProps} />,
      layout: "/admin",
    },
    {
      path: "/torneos",
      name: "torneos",
      icon: "flick icon-field-hockey",
      component: <Torneos {...loadingProps} />,
      layout: "/admin",
    },
    {
      path: "/resultados",
      name: "resultados",
      icon: "fas fa-list-ol",
      component: <Resultados {...loadingProps} />,
      layout: "/admin",
    },
    {
      path: "/noticias",
      name: "noticias",
      icon: "fas fa-newspaper",
      component: <Noticias {...loadingProps} />,
      layout: "/admin",
      oculto: true, // feature deshabilitada por ahora: la ruta sigue viva pero no se muestra en el menú
    },
    {
      path: "/usuarios",
      name: "usuarios",
      icon: "fas fa-users",
      component: <Usuarios {...loadingProps} />,
      layout: "/admin",
    },
  ];

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(mainPanel.current);
    } else document.documentElement.className += " perfect-scrollbar-off";

    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.documentElement.className += " perfect-scrollbar-off";
        document.documentElement.classList.remove("perfect-scrollbar-on");
      } else document.documentElement.classList.remove("perfect-scrollbar-off");
    };
  });
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;
  }, [location]);
  const minimizeSidebar = () => {
    // var message = "Sidebar mini ";
    if (document.body.classList.contains("sidebar-mini")) {
      setSidebarMini(false);
      // message += "deactivated...";
    } else {
      setSidebarMini(true);
      // message += "activated...";
    }
    document.body.classList.toggle("sidebar-mini");
    // var options = {};
    // options = {
    //   place: "tr",
    //   message: message,
    //   type: "info",
    //   icon: "now-ui-icons ui-1_bell-53",
    //   autoDismiss: 7,
    // };
    // notificationAlert.current.notificationAlert(options);
  };

  // const getActiveRoute = (routes) => {
  //   let activeRoute = "Default Brand Text";
  //   for (let i = 0; i < routes.length; i++) {
  //     if (routes[i].collapse) {
  //       let collapseActiveRoute = getActiveRoute(routes[i].views);
  //       if (collapseActiveRoute !== activeRoute) {
  //         return collapseActiveRoute;
  //       }
  //     } else {
  //       if (window.location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
  //         return routes[i].name;
  //       }
  //     }
  //   }
  //   return activeRoute;
  // };

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return <Route path={prop.path} element={prop.component} key={key} exact />;
      } else {
        return null;
      }
    });
  };

  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (window.location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  return (
    <>
      <div className="wrapper">
        <Sidebar {...props} routes={routes} minimizeSidebar={minimizeSidebar} backgroundColor={backgroundColor} />
        <div className="main-panel" ref={mainPanel}>
          <AdminNavbar
            {...props}
            brandText={
              location.pathname.indexOf("/dashboard") !== -1 ? dashboardTitle || "Dashboard" : getActiveRoute(routes)
            }
          />
          <Routes>
            {getRoutes(routes)}
            {/* <Route path="/torneos" element={<Torneos />} />
            <Route path="/jugadores" element={<Jugadores />} /> */}
            <Route path="/torneos/:id" element={<TorneosForm {...loadingProps} />} />
            <Route path="/sedes/:id" element={<SedesForm {...loadingProps} />} />
            <Route path="/usuarios/:id" element={<UsuariosForm {...loadingProps} />} />
            <Route path="/equipos/:id" element={<EquiposForm {...loadingProps} />} />
            <Route path="/jugadores/:id" element={<JugadoresForm {...loadingProps} />} />
            <Route path="/noticias/:id" element={<NoticiasForm {...loadingProps} />} />
            <Route path="/dashboard" element={<Dashboard {...loadingProps} onTorneoLoaded={setDashboardTitle} />} />
            <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
          </Routes>
        </div>
      </div>
    </>
  );
};

export default Admin;
